module.exports = __webpack_public_path__ + "static/img/RIFF (1).423c821.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/riff/RIFF (1).png
// module id = sO2D
// module chunks = 13